import $ from "jquery";
import {showToastNotify, TOASTR_ERROR} from "./helpers";
import {sendWithdrawQuery} from "./withdraw";
import {sendLoanRequestQuery} from "./instant";
import {sendDisableGgAuthQuery, getAuthSecretCode} from "./settings";

let operationType = '';

const LOAN_REQUEST_OPERATION_TYPE = 'loanRequest',
      WITHDRAW_OPERATION_TYPE = 'withdrawRequest',
      DISABLE_GG_AUTH_QUERY = 'disableGgAuthQuery',
      SHOW_SECRET_CODE = 'secretGgAuthCode';

const showOperationConfirmModal = () => {
    $('#confirmGgAuthCode').modal('show');
}

const closeOperationConfirmModal = () => {
    $('#confirmGgAuthCode').modal('hide');
}

const checkConfirmAuthCode = () => {
    const authKey = $('#operation-gg-auth-code').val();
    const notAskConfirmation = $('#not_ask_confirmation').prop('checked');
    const data = {
        '2fa_key': authKey,
        'notAskConfirmation': notAskConfirmation
    };
    sendCheckAuthCode('/confirm-auth-code', data, true);
}

const checkSettingConfirmAuthCode = () => {
    const authKey = $('#setting-gg-auth-code-confirm').val();
    const data = {
        '2fa_key': authKey,
    };
    sendCheckAuthCode('/confirm-auth-code', data, true);
}

export const confirmAuthCode = (operation_type) => {
    operationType = operation_type;
    showOperationConfirmModal();
}

export const needOperationConfirmAuthCode = () => {
    return $('#enable_gg').text();
}

export const needSettingConfirmAuthCode = () => {
    return $('#enable_gg_fa').text();
}

const sendCheckAuthCode = (url, data, needReturn = false) => {
    return $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            let message = 'Something wrong';
            if (result) {
                if (result.msg) {
                    message = result.msg
                }
                if (!result.error) {
                    if (needReturn && result.success) {
                        closeOperationConfirmModal();
                        if (operationType === WITHDRAW_OPERATION_TYPE) {
                            sendWithdrawQuery();
                        }
                        if (operationType === LOAN_REQUEST_OPERATION_TYPE) {
                            sendLoanRequestQuery();
                        }
                        if (operationType === DISABLE_GG_AUTH_QUERY) {
                            sendDisableGgAuthQuery();
                        }
                        if (operationType === SHOW_SECRET_CODE) {
                            getAuthSecretCode();
                        }
                    }
                } else {
                    showToastNotify(TOASTR_ERROR, '', message)
                }
            }
        }
    });
}

window.checkConfirmAuthCode = checkConfirmAuthCode;
window.checkSettingConfirmAuthCode = checkSettingConfirmAuthCode;
